'use strict';
var MediaQueryMatchType;
(function (MediaQueryMatchType) {
    MediaQueryMatchType["Max"] = "max";
    MediaQueryMatchType["Min"] = "min";
})(MediaQueryMatchType || (MediaQueryMatchType = {}));
export default MediaQueryMatchType;
